module.exports = __webpack_public_path__ + "static/media/carousel-new-1.59171d46.png";